$.fn.slickZoom = function (options) {
  options = options || {};

  $(this).each(function(i) {
    var container = $(this);
    options.item = options.item || '.' + container.children().attr('class');
    var items = container.find(options.item);
    var slickOptions = options.slickOptions || {
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 660,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    var slickInstance = items.length >= 2 ? container.slick(slickOptions) : null;

    // init photoswipe
    container
      .attr('data-pswp-uid', i+1)
      .on('click', options.item, function (e) {
        e.preventDefault();
        var slideItem = $(this);
        var index = slideItem.index() - (slideItem.siblings('.slick-slide.slick-cloned').length - $('.count_blocks').attr('data-count'));
        console.log(index);
        console.log(container);
        openPhotoSwipe(index, container);
      });

    function openPhotoSwipe(index, $gallery) {
      var pswpElement = $('.pswp')[0];
      var images = parseImages($gallery);

      var photoSwipeOptions = options.photoSwipeOptions || {
        fullscreenEl: false,
        index: parseInt(index, 10),
        galleryUID: $gallery.attr('data-pswp-uid'),
        history: false,
        getThumbBoundsFn: function(index) {
          // to make the open/close animation
          var rect = images[index].el.getBoundingClientRect();
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      // Pass data to PhotoSwipe and initialize it
      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, photoSwipeOptions);
      gallery.init();

      // slide the slick carouel in the background when the zoom carouel is moving
      if (slickInstance) {
        gallery.listen('beforeChange', function() {
          var slideItem = $(gallery.currItem.el).closest(options.item);
          var currentIndex = slideItem.index() - (slideItem.siblings('.slick-slide.slick-cloned').length - 5);
          console.log(currentIndex);
          slickInstance.slick('slickGoTo', currentIndex);
        });
      }
    };

    function parseImages(el) {
      return el.find(options.item + ':not(.slick-cloned) img').map(function() {
        return {
          el: this,
          src: this.src,
          msrc: this.src,
          w: this.naturalWidth,
          h: this.naturalHeight
        };
      }).get();
    }

  });
}

$.fn.slickZoomWholesale = function (options) {
  options = options || {};

  $(this).each(function(i) {
    var container = $(this);
    options.item = options.item || '.' + container.children().attr('class');
    var items = container.find(options.item);
    var slickOptions = options.slickOptions || {
      slidesToShow: 5,
      slidesToScroll: 5,
      infinite: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 660,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    var slickInstance = items.length >= 2 ? container.slick(slickOptions) : null;

    // init photoswipe
    container
      .attr('data-pswp-uid', i+1)
      .on('click', options.item, function (e) {
        e.preventDefault();
        var slideItem = $(this);
        if (slideItem.siblings('.slick-slide.slick-cloned').length > 0){
			var index = slideItem.index() - (slideItem.siblings('.slick-slide.slick-cloned').length - $('.count_blocks').attr('data-count'));
        }else{
        	var index = slideItem.index();
        }
        console.log(index);
        console.log(container);
        openPhotoSwipe(index, container);
      });

    function openPhotoSwipe(index, $gallery) {
      var pswpElement = $('.pswp')[0];
      var images = parseImages($gallery);

      var photoSwipeOptions = options.photoSwipeOptions || {
        fullscreenEl: false,
        index: parseInt(index, 10),
        galleryUID: $gallery.attr('data-pswp-uid'),
        history: false,
        getThumbBoundsFn: function(index) {
          // to make the open/close animation
          var rect = images[index].el.getBoundingClientRect();
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };

      // Pass data to PhotoSwipe and initialize it
      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, photoSwipeOptions);
      gallery.init();

      // slide the slick carouel in the background when the zoom carouel is moving
      if (slickInstance) {
        gallery.listen('beforeChange', function() {
          var slideItem = $(gallery.currItem.el).closest(options.item);
          if (slideItem.siblings('.slick-slide.slick-cloned').length > 0){
			var currentIndex = slideItem.index() - (slideItem.siblings('.slick-slide.slick-cloned').length - 5);
          }else{
            var currentIndex = slideItem.index();
          }

          console.log(currentIndex);
          slickInstance.slick('slickGoTo', currentIndex);
        });
      }
    };

    function parseImages(el) {
      return el.find(options.item + ':not(.slick-cloned) img').map(function() {
        return {
          el: this,
          src: this.src,
          msrc: this.src,
          w: this.naturalWidth,
          h: this.naturalHeight
        };
      }).get();
    }

  });
  }
